import Entity from './entity'

const Quickbooks = new Entity('quickbooks')

export default Quickbooks
